import React, { useState } from 'react';
import { Alert, Button, Card, Col, Descriptions, Drawer, Image, Popconfirm, Row, Space } from 'antd';
import { formatCurrency } from 'utils/number';

const getLineImage = (line) => {
  const image = line?.variant?.image
    || line?.variant?.images?.[0]
    || line?.product?.thumbnail
    || line?.product?.image
    || line?.product?.images?.[0]
    || null;

  if (!image) return null;
  if (typeof image === 'string') return image;
  return image?.url || null;
};

const OrderDetailMobile = ({ viewModel }) => {
  const [showActionSheet, setShowActionSheet] = useState(false);

  const {
    data,
    customer,
    lineItems,
    id,
    navigate,
    setIsModalPaymentProofOpen,
    setShowOrderPayment,
    setShowOrderHistoryModal,
    setShowOrderNoteModal,
    cancelOrder,
    finishOrder,
    createInvoice,
    createPackingList,
    createShippingLabel,
  } = viewModel;

  const shippingStatusTitle = data.shipping_status?.title || data.shipping_status_id || '-';
  const internalStatusId = data.internal_status?.id || data.internal_status_id || data.internal?.status?.id;
  const internalStatusTitle = data.internal_status?.title
    || data.internal?.status?.title
    || data.store_setting?.order_internal_status_map?.[internalStatusId]?.title
    || internalStatusId
    || '-';

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Card>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          {data.status == 'canceled' && (
            <Alert
              message="Đơn hàng này đã bị huỷ"
              description={`Lý do huỷ: ${data.cancel?.reason || ''}`}
              type="error"
              closable
            />
          )}

          {data.status == 'finalized' && (
            <Alert
              message="Đơn hàng này đã hoàn tất"
              description={`Ghi chú: ${data.finalized?.note || ''}`}
              type="success"
              closable
            />
          )}

          <Descriptions>
            <Descriptions.Item label="Mã đơn hàng">{data.id}</Descriptions.Item>
            <Descriptions.Item label="Khách hàng">{customer.full_name}</Descriptions.Item>
            <Descriptions.Item label="SDT">{customer.phone}</Descriptions.Item>
            <Descriptions.Item label="Thanh toán" span={3}>{data.payment_status?.title}</Descriptions.Item>
            <Descriptions.Item label="Vận chuyển" span={3}>{shippingStatusTitle}</Descriptions.Item>
            <Descriptions.Item label="Nội bộ" span={3}>{internalStatusTitle}</Descriptions.Item>
            <Descriptions.Item label="Địa chỉ" span={3}>{data.shipping_address?.address}</Descriptions.Item>
            <Descriptions.Item label="Ghi Chú" span={3}>{data.note}</Descriptions.Item>
          </Descriptions>

          {data.commission > 0 && (
            <Descriptions>
              <Descriptions.Item label="Hoa hồng" span={3}>{formatCurrency(data.commission)}</Descriptions.Item>
            </Descriptions>
          )}

          <Button type="primary" block onClick={() => setShowActionSheet(true)}>
            Chức năng
          </Button>

          <Drawer
            title="Chức năng"
            placement="bottom"
            open={showActionSheet}
            onClose={() => setShowActionSheet(false)}
            height="auto"
          >
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              <Button
                type="primary"
                block
                onClick={() => {
                  navigate(`/order/edit/${id}`);
                  setShowActionSheet(false);
                }}
              >
                Sửa
              </Button>

              <Button
                block
                onClick={() => {
                  setShowOrderPayment(true);
                  setShowActionSheet(false);
                }}
              >
                Thanh toán
              </Button>

              {data.payment_proof?.image && (
                <Button
                  block
                  onClick={() => {
                    setIsModalPaymentProofOpen(true);
                    setShowActionSheet(false);
                  }}
                >
                  Thông tin thanh toán
                </Button>
              )}

              <Button
                block
                onClick={() => {
                  setShowOrderNoteModal(true);
                  setShowActionSheet(false);
                }}
              >
                Ghi chú
              </Button>

              <Button
                block
                onClick={() => {
                  setShowOrderHistoryModal(true);
                  setShowActionSheet(false);
                }}
              >
                Lịch sử
              </Button>

              <Button
                type="primary"
                block
                onClick={() => {
                  createInvoice();
                  setShowActionSheet(false);
                }}
              >
                In Hoá Đơn
              </Button>

              <Button
                type="primary"
                block
                onClick={() => {
                  createPackingList();
                  setShowActionSheet(false);
                }}
              >
                In Phiếu Đóng Gói
              </Button>

              <Button
                type="primary"
                block
                onClick={() => {
                  createShippingLabel();
                  setShowActionSheet(false);
                }}
              >
                In Tem Vận Chuyển
              </Button>

              <Popconfirm
                title="Hoàn tất"
                description="Bạn có chắc chắn muốn hoàn tất đơn hàng này?"
                onConfirm={() => {
                  setShowActionSheet(false);
                  finishOrder();
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button block>Hoàn tất</Button>
              </Popconfirm>

              <Popconfirm
                title="Huỷ đơn hàng"
                description="Bạn có chắc chắn muốn huỷ đơn hàng này?"
                onConfirm={() => {
                  setShowActionSheet(false);
                  cancelOrder();
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button danger block>Huỷ</Button>
              </Popconfirm>
            </Space>
          </Drawer>
        </Space>
      </Card>

      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Card>
            <table style={{ width: '100%' }} className="tbl_order">
              <colgroup>
                <col></col>
                <col style={{ textAlign: 'right' }}></col>
              </colgroup>
              <tbody className="ant-table-tbody">
                <tr>
                  <td>Tiền hàng</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.sub_amount)}</td>
                </tr>
                <tr>
                  <td>Giảm giá</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.discount_amount)}</td>
                </tr>
                <tr>
                  <td>Mã khuyến mãi</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.voucher_amount)}</td>
                </tr>
                <tr>
                  <td>Xu</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.point_discount)}</td>
                </tr>
                <tr>
                  <td>Phí ship</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.shipping_amount)}</td>
                </tr>
                <tr>
                  <td>Tổng tiền</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(data.total_amount)}</td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Col>

        <Col span={24}>
          <Card>
            <table className="tbl_order" style={{ width: '100%' }}>
              <colgroup>
                <col style={{ width: '35%' }}></col>
                <col style={{ width: 35 }}></col>
              </colgroup>

              <tr>
                <th>Sản phẩm</th>
                <th>Sl</th>
                <th>Đơn giá</th>
                <th>Thành tiền</th>
              </tr>

              <tbody className="ant-table-tbody">
                {lineItems.map((line) => (
                  <tr key={`${line.product?.id || ''}-${line.variant?.id || ''}-${line.id || ''}`}>
                    <td>
                      <Space size={8}>
                        {getLineImage(line) && (
                          <Image
                            src={getLineImage(line)}
                            width={32}
                            height={32}
                            style={{ objectFit: 'cover', borderRadius: 6 }}
                            fallback='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjZjVmNWY1Ii8+PC9zdmc+'
                          />
                        )}
                        <span>{line.product?.name} {line.variant?.variant_title}</span>
                      </Space>
                    </td>
                    <td style={{ textAlign: 'right' }}>{line.quantity}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(line.price)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(line.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default OrderDetailMobile;
